<template>
  <fragment>
    <v-breadcrumbs :items="routesBack" class="links-breadcrumbs px-0">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <v-tabs
      v-model="tab"
      class="rounded-lg pb-2"
      background-color="primary"
      color="dark"
      grow
      v-if="isAdmin"
    >
      <v-tabs-slider color="primary"></v-tabs-slider>
      <div class="tabs-style">
        <v-tab active-class="slide"> Ecommerce </v-tab>
        <v-tab active-class="slide"> Marketplace </v-tab>
      </div>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <AppBody subtitle="Ordenar Ecommerce">
          <ecommerce />
        </AppBody>
      </v-tab-item>
      <v-tab-item>
        <AppBody subtitle="Ordenar Marketplace">
          <marketplace />
        </AppBody>
      </v-tab-item>
    </v-tabs-items>
    <div v-if="!isAdmin">
      <AppBody subtitle="Ordenar Ecommerce">
        <ecommerce />
      </AppBody>
    </div>
    <Loader
      msg="Organizando seus produtos conforme sua preferência. Aguarde, por favor."
      v-if="ordering_loading"
    />
  </fragment>
</template>
<script>
import ecommerce from "@/components/produtos/orderProducts/ecommerce.vue";
import marketplace from "@/components/produtos/orderProducts/marketplace.vue";
import AppBody from "@/layouts/components/AppBody.vue";
import Loader from "@/components/loader/loader.vue";
import { mapGetters } from "vuex";

export default {
  name: "OrderEvents",
  data() {
    return {
      tab: null,
      routesBack: [
        {
          text: "Produtos - Gerenciar",
          disabled: false,
          to: "/gerenciar",
        },
        {
          text: "Ordenação",
          disabled: true,
        },
      ],
    };
  },
  components: {
    Loader,
    ecommerce,
    marketplace,
    AppBody,
  },
  computed: {
    ...mapGetters(["ordering_loading"]),
    isAdmin() {
      if (this.$axios.getLocal("oe_user_info")?.data?.user_type === "admin")
        return true;
      return false;
    },
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  destroyed() {
    this.$orderProducts.cleanFilters();
    this.$orderProducts.cleanProducts();
  },
};
</script>

<style scoped lang="scss">
.slide {
  background-color: var(--v-tertiary-base);
  border-radius: 8px;
  color: white;
  font-weight: bold;
  transition: transform ease-in-out 0.2s;
}
.tabs-style {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0.33rem 0.5rem;
}
.v-size--small {
  padding: 0 !important;
}
</style>
